// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2FwZE","form":"styles_form__2gGKI"};